import type { Pinia } from 'pinia';
import type { App } from 'vue';

const logErrorToConsole = (source: string, error: unknown): void => {
  const technicalMessage =
    error instanceof Error ? error.message : typeof error === 'string' ? error : undefined;

  if (technicalMessage) {
    console.error(`[${source}] ${technicalMessage}`, error);
    return;
  }

  console.error(`[${source}] Unknown runtime error`, error);
};

export const registerGlobalErrorHandling = (app: App, _pinia: Pinia): void => {
  void _pinia;
  const existingErrorHandler = app.config.errorHandler;

  app.config.errorHandler = (err, instance, info) => {
    logErrorToConsole(`Vue error${info ? `: ${info}` : ''}`, err);

    if (existingErrorHandler) {
      existingErrorHandler(err, instance, info);
    }
  };

  window.addEventListener('error', (event) => {
    logErrorToConsole('Window error', event.error ?? event.message);
    // Prevent browser default handling from interrupting UX flow.
    event.preventDefault();
  });

  window.addEventListener('unhandledrejection', (event) => {
    logErrorToConsole('Unhandled promise rejection', event.reason);
    // Treat unhandled promise rejections as non-blocking global errors.
    event.preventDefault();
  });
};
